import types from "./types";
import { produce } from "immer";

const INITIAL_STATE = {
    colaboradores: [],
    components: {
        loading: true,
        error: null,
    },
};

function colaboradores(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.UPDATE_COLABORADORES: {
            return produce(state, (draft) => {
                draft.colaboradores = action.colaboradores;
                draft.components.loading = false;
                draft.components.error = null;
                return draft;
            });
        }
        case types.UPDATE_COMPONENT: {
            return produce(state, (draft) => {
                draft.components = { ...state.components, ...action.component };
                return draft;
            });
        }
        default:
            return state;
    }
}

export default colaboradores;
